export default __webpack_public_path__ + "db9fe59cac548ea86514ec0598c8facb.jpg";